import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { withRouter } from "react-router-dom";
import FacilityWizard from "./FacilityWizard";
import { loadFacilityHeader } from "../actionCreators";
import { getInt } from "utils/functions";
import { getFacilityHeader } from "../selectors";
import documentTypeIds from "constants/documentTypeIds";

const FacilityWizardRouteContainer = ({ match, history, location }) => {
  const documentId = getInt(match.params.documentId);
  const siteId = getInt(match.params.siteId);
  const isNewFacility = match.params.newFacility && match.params.newFacility === "new";

  const dispatch = useDispatch();

  const { loaded, content: facilityHeader } = useSelector(state => getFacilityHeader(state, documentId, documentTypeIds.Facility), shallowEqual);

  useEffect(() => {
    if (isNewFacility) return;
    dispatch(loadFacilityHeader(documentId, siteId));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (facilityHeader.loaded || facilityHeader.loading || isNewFacility) return;
    dispatch(loadFacilityHeader(documentId, siteId));
  }, [documentId, siteId, loaded]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    (isNewFacility || loaded) && (
      <FacilityWizard
        documentId={documentId}
        siteId={siteId}
        isNewFacility={isNewFacility}
        facilityHeader={facilityHeader}
        history={history}
        locationPathName={location.pathname}
      />
    )
  );
};

FacilityWizardRouteContainer.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object,
  history: PropTypes.object.isRequired
};

export default withRouter(FacilityWizardRouteContainer);
